import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import google from './google';
import IconButton from '../IconButton/IconButton';
var Map = /*#__PURE__*/function (_React$Component) {
  function Map(props) {
    var _this;
    _classCallCheck(this, Map);
    _this = _callSuper(this, Map, [props]);
    _this.state = {
      inputValue: ''
    };
    _this.bindings = {
      onGeolocationButtonClick: _this.onGeolocationButtonClick.bind(_this),
      onInputChange: _this.onInputChange.bind(_this),
      trackInput: _this.trackInput.bind(_this)
    };
    _this.styles = {
      iconSearch: {
        cursor: 'default',
        opacity: '.25'
      },
      iconCrosshairs: {
        opacity: '.5'
      }
    };
    return _this;
  }
  _inherits(Map, _React$Component);
  return _createClass(Map, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      var map;
      var marker;
      var autocomplete;
      var autocompleteOptions = {};
      var api = this.context.api;
      var _this$props = this.props,
        bucketSize = _this$props.bucketSize,
        latitude = _this$props.latitude,
        longitude = _this$props.longitude;
      var allCountry = 505;
      if (api && this.container && !this.map || bucketSize !== prevProps.bucketSize) {
        map = new api.Map(this.container, {
          center: {
            lat: latitude,
            lng: longitude
          },
          zoom: 13,
          disableDefaultUI: true,
          scrollwheel: false,
          zoomControl: true
        });
        var markerOptions = {
          map: map,
          position: map.getCenter(),
          draggable: true
        };
        if (bucketSize && bucketSize !== allCountry) {
          markerOptions.icon = {
            url: "data:image/svg+xml;utf-8,                         <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"33\" viewBox=\"0 0 22 33\">                            <g fill=\"none\" fill-rule=\"evenodd\">                                <ellipse cx=\"10.423\" cy=\"30.486\" fill=\"#000\" fill-opacity=\".87\" opacity=\".7\" rx=\"6.068\" ry=\"1.866\"/>                                <path fill=\"#009AAB\" d=\"M10.577 0C4.684 0 0 4.725 0 10.67c0 7.927 10.577 19.816 10.577 19.816s10.577-11.89 10.577-19.816C21.154 4.725 16.47 0 10.577 0zm0 14.48c-2.116 0-3.778-1.676-3.778-3.81 0-2.134 1.662-3.81 3.778-3.81 2.115 0 3.777 1.676 3.777 3.81 0 2.134-1.662 3.81-3.777 3.81z\"/>                            </g>                        </svg>                    "
          };
        }
        if (bucketSize === allCountry) {
          var geocoder = new api.Geocoder();
          geocoder.geocode({
            address: this.props.countryString
          }, function (results) {
            var country = results.length === 1 ? results[0] : results.pop();
            map.fitBounds(country.geometry.viewport);
            map.setCenter(country.geometry.location);
          });
        }
        if (bucketSize !== allCountry) {
          marker = new api.Marker(markerOptions);
        }
        if (bucketSize && bucketSize !== allCountry) {
          var metersToKm = 1000;
          var radius = bucketSize * metersToKm;
          var circleOptions = {
            strokeColor: '#90dfd1',
            strokeOpacity: 0.8,
            strokeWeight: 1,
            fillColor: '#90dfd1',
            fillOpacity: 0.46,
            map: map,
            center: map.getCenter(),
            radius: radius
          };
          var circle = new api.Circle(circleOptions);
          circle.bindTo('center', marker, 'position');
          map.fitBounds(circle.getBounds());
        }
        if (bucketSize !== allCountry) {
          marker.addListener('dragstart', function () {
            map.set('dragging', true);
          });
          marker.addListener('dragend', function () {
            map.set('dragging', false);
            map.panTo(marker.getPosition());
          });
          map.set('marker', marker);
        }
        if (this.props.country) {
          autocompleteOptions.componentRestrictions = {
            country: this.props.country
          };
        }
        autocomplete = new api.places.Autocomplete(this.input, autocompleteOptions);
        map.controls[api.ControlPosition.TOP_LEFT].push(this.autocomplete);
        autocomplete.addListener('place_changed', function () {
          var place = autocomplete.getPlace();
          if (place && place.geometry && place.geometry.location) {
            _this2.trackInput();
            map.panTo(place.geometry.location);
          }
        });
        map.set('autocomplete', autocomplete);
        api.event.addListenerOnce(map, 'idle', function () {
          map.addListener('dragstart', function () {
            map.set('dragging', true);
          });
          map.addListener('dragend', function () {
            map.set('dragging', false);
            api.event.trigger(map, 'idle');
          });
          _this2.map.addListener('idle', function () {
            var center = map.getCenter();
            var _center$toJSON = center.toJSON(),
              latitude = _center$toJSON.lat,
              longitude = _center$toJSON.lng;
            if (!map.get('dragging')) {
              if (bucketSize !== allCountry) {
                map.get('marker').setPosition(center);
              }
              if (_this2.props.onChange) {
                _this2.props.onChange(latitude, longitude);
              }
            }
          });
        });
        this.map = map;
      }
    }
  }, {
    key: "onGeolocationButtonClick",
    value: function onGeolocationButtonClick() {
      var _this3 = this;
      if (navigator && navigator.geolocation && this.map) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var _position$coords = position.coords,
            latitude = _position$coords.latitude,
            longitude = _position$coords.longitude;
          _this3.map.setCenter({
            lat: latitude,
            lng: longitude
          });
        });
      }
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(event) {
      this.setState({
        inputValue: event.target.value
      });
    }
  }, {
    key: "trackInput",
    value: function trackInput() {
      var _this4 = this;
      var autocompleteService = new this.context.api.places.AutocompleteService();
      var autocompleteServiceOptions = {
        input: this.input.value,
        componentRestrictions: {
          country: this.props.country
        }
      };
      var maxPredictions = 8;
      var maxDescription = 20;
      autocompleteService.getPlacePredictions(autocompleteServiceOptions, function (predictions) {
        var searchPredictions = predictions.slice(0, maxPredictions);
        searchPredictions = searchPredictions.map(function (prediction) {
          return {
            q: prediction.description.slice(0, maxDescription),
            t: 'ac'
          };
        });
        if (_this4.props.trackLocationInput) {
          _this4.props.trackLocationInput({
            origin: 'filters',
            search_type: 'autocomplete',
            search_string: _this4.input.value,
            search_user_query: _this4.state.inputValue,
            search_autocomplete_suggestions: searchPredictions
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(container) {
          return _this5.container = container;
        },
        className: this.props.className
      }, this.context.api && /*#__PURE__*/React.createElement("div", {
        ref: function ref(autocomplete) {
          return _this5.autocomplete = autocomplete;
        },
        className: this.props.autocompleteClassName
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
        icon: "icon-Search",
        name: "search",
        style: this.styles.iconSearch
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("input", {
        ref: function ref(input) {
          return _this5.input = input;
        },
        onChange: this.bindings.onInputChange
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
        icon: "icon-Crosshairs",
        name: "geolocate",
        onClick: this.bindings.onGeolocationButtonClick,
        style: this.styles.iconCrosshairs
      })))));
    }
  }]);
}(React.Component);
Map.contextTypes = {
  api: PropTypes.object
};
Map.defaultProps = {
  className: '',
  api: null,
  onChange: function onChange() {},
  trackLocationInput: function trackLocationInput() {},
  country: '',
  countryString: '',
  bucketSize: null
};
export default google(Map);